export default {
  groupMap (map, property) {
    var reducedObj = map.reduce((accumulator, obj) => {
      var key = obj[property]
      // Create a new insert if key does not exist
      if (!accumulator[key]) {
        accumulator[key] = []
      }
      accumulator[key].push(obj)
      return accumulator
    }, {})

    /* var retArray = []
    Object.keys(reducedObj).forEach(key => {
      retArray.push(reducedObj[key])
    }) */

    return reducedObj
  },
  arrayUnique (_array) {
    return _array.filter(function (elem, pos, arr) {
      return arr.indexOf(elem) === pos
    })
  },
  arrayRemove (array, element) {
    return array.filter(e => e !== element)
  }
}
